<template>
  <el-dialog title="配置热门院校" :visible.sync="dialogVisible" width="800px">
    <div class="filter-container">
      <el-button
        class="filter-item"
        @click="handleSchoolAdd"
        type="primary"
        icon="el-icon-circle-plus-outline"
        >添加</el-button
      >
      <span style="margin-left: 20px;">*最多添加20所院校</span>
    </div>
    <el-table
      :data="list"
      v-loading.body="listLoading"
      element-loading-text="加载中 ..."
      border
      highlight-current-row
    >
      <el-table-column
        type="index"
        align="center"
        label="序号"
        width="90"
      ></el-table-column>
      <el-table-column
        label="学校名称"
        width="300"
        align="center"
        prop="name"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="排序" width="200" align="center" prop="order">
        <template slot-scope="{ row }">
          <el-input-number
            style="width: 100%;"
            size="mini"
            v-model="row.order"
            :min="0"
            :precision="0"
            :controls="false"
            v-if="row.isEditOrder"
            v-focus
            @blur="handleSaveOrder(row)"
          ></el-input-number>
          <span class="span-td" v-else @click.prevent="handleClickOrder(row)">{{
            row.order
          }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            icon="el-icon-delete"
            @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>

    <el-dialog
      title="添加院校"
      :visible.sync="schoolAddVisible"
      width="600px"
      append-to-body
    >
      <el-form label-position="left" label-width="90px">
        <el-form-item label="院校">
          <el-select
            style="width: 300px"
            v-model="school"
            clearable
            multiple
            filterable
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in schoolOptions"
              :key="index"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button plain @click="schoolAddVisible = false">取消</el-button>
        <el-button type="primary" @click="onAddConfirm">确定</el-button>
      </template>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  getSchoolHotSchool,
  getSchoolDPSchool,
  postSchoolHotSchool,
  deleteSchoolHotSchool,
  patchSchoolHotSchool,
} from '@/api/pick_school';
export default {
  name: 'DialogHotSchool',
  data() {
    return {
      dialogVisible: false,
      uuid: '',
      first_level: '',
      list: null,
      count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        size: 10,
      },

      editOrder: 0,

      schoolAddVisible: false,
      schoolOptions: [],
      school: [],
    };
  },
  methods: {
    show(uuid, first_level) {
      this.dialogVisible = true;
      this.uuid = uuid;
      this.first_level = first_level;
      this.fetchData();
    },
    // 获取数据
    fetchData() {
      this.listLoading = true;
      getSchoolHotSchool(this.uuid, this.listQuery).then(res => {
        const list = res.data.results || [];
        list.forEach(item => {
          item.isEditOrder = false;
        });
        this.list = list;
        this.count = res.data.count;
        this.listLoading = false;
      });
    },
    // 修改排序值
    handleClickOrder(row) {
      this.editOrder = row.order;
      row.isEditOrder = true;
    },
    handleSaveOrder(row) {
      this.$confirm('确认修改该排序吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          patchSchoolHotSchool(this.uuid, {
            code: row.code,
            name: row.name,
            order: row.order,
          })
            .then(() => {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
              });
              this.fetchData();
              row.isEditOrder = false;
            })
            .catch(() => {
              row.order = this.editOrder;
              row.isEditOrder = false;
            });
        })
        .catch(() => {
          row.order = this.editOrder;
          row.isEditOrder = false;
        });
    },
    handleDel(row) {
      this.$confirm('确认删除该院校吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteSchoolHotSchool(this.uuid, {
            code: row.code,
            name: row.name,
          }).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
            });
            this.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSchoolAdd() {
      const { first_level, count } = this;
      if (count >= 20) {
        return this.$message('最多添加20所院校');
      }
      this.school = [];
      getSchoolHotSchool(this.uuid, {
        page: 1,
        size: 20,
      }).then(res => {
        this.school = (res.data.results || []).map(item => item.code);
      });
      getSchoolDPSchool({
        first_level,
      }).then(res => {
        this.schoolOptions = res.data || [];
        this.schoolAddVisible = true;
      });
    },
    onAddConfirm() {
      const { school, schoolOptions } = this;
      if (!school || !school.length) {
        return this.$message.error('请选择要添加的院校');
      }
      this.$confirm('确认添加院校吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          postSchoolHotSchool(this.uuid, {
            school: schoolOptions.filter(item => school.includes(item.code)),
          }).then(() => {
            this.$notify({
              title: '成功',
              message: '添加成功',
              type: 'success',
            });
            this.schoolAddVisible = false;
            this.fetchData();
          });
        })
        .catch(() => {});
    },
  },
  directives: {
    focus: {
      inserted: function(el) {
        const input = el.querySelector('input');
        input.focus();
      },
    },
  },
};
</script>

<style></style>
